import React, {useState} from 'react'
import {CabinetAccordion, CabinetAccordionDetails, CabinetAccordionSummary} from "../../../settings/cabinetAccordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {Grid, makeStyles, Slide, Snackbar, useMediaQuery} from "@material-ui/core";
import {Line} from "react-chartjs-2";
import {Loading, SwipeStyledButton} from "@cabinet-packages/components";
import CircleIcon from "@material-ui/icons/RadioButtonUnchecked";
import HelpIcon from "@material-ui/icons/Help";
import {getAssayValuesFromHistory, getChartData, getChartOptions} from "../../../utils/getChartOptions";
import {getAssay} from "@cabinet-packages/api/api";
import {addAssayToOrderList} from "@cabinet-packages/redux";
import {setActiveStep} from "@cabinet-packages/redux/moduleReducers/wizardStepperReducer/serviceMidleware";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    summaryContainer: {
        height: "60px !important",
        "@media(max-width: 900px)": {
            height: 'max-content !important'
        }
    },
    expandedInnerAccordion: {
        boxShadow: 'none !important'
    },
    innerSummaryRoot: {
        padding: '0px 30px 0px 10px'
    },
    columnLabel: {
        fontSize: '12px',
        color: theme.palette.grey.text,
        fontWeight: 500,
        '@media(max-width: 900px)': {
            fontSize: '9px'
        }
    },
    researchLabel: {
        fontSize: '14px',
        fontWeight: 600,
        '@media(max-width: 900px)': {
            fontSize: '12px',
            fontWeight: 600,
        }
    },
    resultLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    orderButton: {
        borderRadius: '2rem',
        border: `1px solid ${theme.palette.colors.text}`,
        fontSize: '15px',
        fontWeight: 600,
        height: '30px',
        color: theme.palette.colors.text,
        transition: '0.5s',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#EAFFFD'
        }
    },
    orderSickButton: {
        borderRadius: '2rem',
        border: `1px solid ${theme.palette.colors.secondary}`,
        fontSize: '15px',
        fontWeight: 600,
        height: '30px',
        color: theme.palette.colors.text,
        transition: '0.5s',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: theme.palette.colors.secondary
        }
    },
    rootExpanded: {
        margin: '10px 0px !important'
    },
    summaryContent: {
        display: 'grid',
        gridGap: '10px',
        gridTemplateColumns: '3.5fr 1fr',
        width: '80%',
        margin: '20px 0px !important',
        '@media(max-width: 900px)': {
            gridTemplateColumns: '1.5fr 1fr',
        }
    },
    charContainer: {
        padding: '5px',
        border: `1px solid ${theme.palette.colors.border}`
    },
    buttonContainer: {
        alignItems: 'center'
    },
    pointsContainer: {
        padding: '20px 0px'
    },
    point: {
        display: 'flex',
        columnGap: '5px',
    },
    pointDesc: {
        fontSize: '12px',
        fontWeight: 700,
        marginTop: '2px',
        '@media(max-width: 900px)': {
            fontSize: '10px'
        }
    },
    helpIcon: {
        color: theme.palette.colors.secondary
    },
    swipeButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0px'
    },
    snackbar: {
        padding: 0,
        background: 'transparent !important',
        borderRadius: '10px',

        '@media (min-width: 1180px)': {
            padding: '0 !important',
            background: 'transparent !important',
            borderRadius: '10px',
        },

        '@media (max-width: 1180px)': {
            width: 'max-content',
            boxShadow: 'none',
        }
    },
    snackbarWrapper: {
        padding: 0,
        background: 'transparent !important',
        borderRadius: '10px',

        '@media (min-width: 1180px)': {
            padding: 0,
            background: 'transparent !important',
            borderRadius: '10px',
        },

        '@media (max-width: 1180px)': {
            width: 'max-content',
            boxShadow: 'none',
            marginBottom: '105px',
            left: 'auto !important',
            right: '8px !important',
        }
    },
    snackbarContentWrapper: {
        width: '340px',
        height: 'max-content',
        background: 'white',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        boxShadow: '2px 0px 10px 0px #70707088',

        '@media (max-width: 1180px)': {
            width: '200px',
        }
    },
    snackbarContentHeader: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        height: '50px',
        width: '100%',
        fontSize: '20px',
        fontWeight: 600,
        color: 'white',
        background: theme.palette.colors.background,
        borderRadius: '10px 10px 0px 0px',

        '@media (max-width: 1180px)': {
            fontSize: '14px',
        }
    },
    snackbarContentText: {
        width: '100%',
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        marginTop: theme.spacing(1),
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 600,
        color: theme.palette.primary.dark,
        lineHeight: 1.43,

        '@media (max-width: 1180px)': {
            fontSize: '14px',
        }
    },
}));

function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
}

const AssayAccordion = ({assay, expanded, setExpanded, catalog, complexResearch}) => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const history = useHistory()
    const mdUp = useMediaQuery(theme => theme.breakpoints.up('md'))
    const isMedis = process.env.REACT_APP_CURRENT_CLINIC === "MEDIS";
    const key = assay.idtest + assay.idclient
    const [options, setOptions] = useState(null)
    const [chartData, setChartData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [snackBarText, setSnackbarText] = useState('');

    const handlePanelChange = (panel) => (event, newExpanded) => {
        setLoading(true)
        setExpanded(newExpanded ? panel : false);
        const assayData = getAssayValuesFromHistory(assay.history)
        setOptions(getChartOptions(assayData))
        setChartData(getChartData(assayData))
        setTimeout(() => {
            setLoading(false)
        }, 1000)
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
        setSnackbarText('');
    };

    const handleRepeatOrder = async (e, orderId) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            const {data} = await getAssay(orderId);

            const foundedAssays = data.reduce((acu, cur) => {
                let foundedAssay;
                if (cur.complex) {
                    foundedAssay = complexResearch.find(item => +item.id === +cur.id && item.code === cur.code);
                } else {
                    foundedAssay = catalog.find(item => +item.id === +cur.id && item.code === cur.code);
                }

                if (foundedAssay) {
                    return [...acu, foundedAssay];
                } else {
                    return acu;
                }
            }, []);

            if (foundedAssays && foundedAssays.length > 0) {
                foundedAssays.forEach(item => {
                    dispatch(addAssayToOrderList(
                        item.id,
                        item.discount
                            ? item.price - item.price * item.discount / 100
                            : item.price,
                        () => {
                        },
                        item.type
                    ))
                })
                history.push('/catalog-table');
                dispatch(setActiveStep(1))
                // } else {
                //     CustomDialog(ConfirmCabinetDialog,
                //         {
                //             text: 'Обране Вами замовлення містить не лише даний аналіз. Бажаєте продовжити ?',
                //             onConfirm: () => {
                //                 foundedAssays.forEach(item => {
                //                     dispatch(addAssayToOrderList(
                //                         item.id,
                //                         item.discount
                //                             ? item.price - item.price * item.discount / 100
                //                             : item.price,
                //                         () => {
                //                         },
                //                         item.type
                //                     ))
                //                 })
                //                 history.push('/wizard');
                //                 dispatch(setActiveStep(1))
                //             }
                //         }, false, themeMaterialUI);
                // }
            } else {
                console.log("ERROR" + e)
                setOpen(true);
                setSnackbarText("Спробуйте замовити дане дослідження через аналізи.")
            }
        } catch (e) {
            console.log("ERROR" + e)
            setOpen(true);
            setSnackbarText("Спробуйте замовити дане дослідження через аналізи.")
        }
    };

    return <>
        <CabinetAccordion
            key={assay.idOrder}
            elevation={0}
            TransitionProps={{
                timeout: 0
            }}
            expanded={expanded === key}
            onChange={handlePanelChange(key)}
             >
            <CabinetAccordionSummary expandIcon={<ExpandMoreIcon color={"primary"}/>} classes={{root: classes.summaryContainer, content: classes.summaryContent}}>
                <div>
                    <Typography color={"textPrimary"} style={{fontSize: mdUp ? '14px' : '13px'}}>
                        {assay.name}
                    </Typography>
                </div>
                {isMedis ? (
                    <Button className={classes.orderButton}
                            onClick={(e) => handleRepeatOrder(e, assay.history[0].idorder)}>
                        Замовити
                    </Button>
                ) : (
                    <Typography className={classes.resultLabel}></Typography>
                )}
            </CabinetAccordionSummary>
            <CabinetAccordionDetails>
                <>
                    {loading ? (
                        <Loading />
                    ) : (
                        <>
                            <Grid container>
                                <Grid item xs={mdUp ? 5 : 12} style={{display: 'flex', flexDirection: 'column', rowGap: '10px', padding: '10px'}}>
                                    <Typography color={"textPrimary"}>
                                        Статистика досліджень за результатами Ваших аналізів
                                    </Typography>
                                </Grid>
                                <Grid item xs={mdUp ? 7 : 12} className={classes.charContainer}>
                                    {options && chartData && (<Line options={options} data={chartData}/>)}
                                </Grid>
                                <Grid item xs={mdUp ? 5 : 12} style={{order: mdUp ? 0 : 1}}>
                                    <div className={classes.swipeButtonContainer}>
                                        <SwipeStyledButton
                                            animationStart={'left'}
                                            style={{width: '170px'}}
                                            onClick={(e) => handleRepeatOrder(e, assay.history[0].idorder)}
                                            animationMaterialColor={isMedis ? "#00B3A1" : "#0077C8"}
                                            buttonMaterialColor={isMedis ? "#FFC101" : "#ffffff"}
                                            hoverTextColor={"#ffffff"}
                                            color={isMedis ? "#0E4E4E" : "#0077C8"}
                                        >
                                            Замовити
                                        </SwipeStyledButton>
                                    </div>
                                </Grid>
                                <Grid item xs={mdUp ? 7 : 12} className={classes.pointsContainer}>
                                    <Grid container>
                                        <Grid item xs={5} className={classes.point}>
                                            <CircleIcon color={"inherit"} style={{color: '#0077C8'}}/>
                                            <Typography className={classes.pointDesc}>
                                                В нормі
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={7} className={classes.point}>
                                            <CircleIcon color={"error"}/>
                                            <div>
                                                <Typography className={classes.pointDesc}>
                                                    Не в нормі
                                                </Typography>
                                                <Typography style={{fontSize: '8px'}}>
                                                    (Необхідно записатися на обстеження)
                                                </Typography>
                                            </div>
                                        </Grid>

                                        {/*<Grid item xs={4} className={classes.point}>*/}
                                        {/*    <HelpIcon className={classes.helpIcon} />*/}
                                        {/*    <div>*/}
                                        {/*        <Typography className={classes.pointDesc}>*/}
                                        {/*            Плановий візит*/}
                                        {/*        </Typography>*/}
                                        {/*        <Typography style={{fontSize: '8px'}}>*/}
                                        {/*            (Рекомендована дата обстеження)*/}
                                        {/*        </Typography>*/}
                                        {/*    </div>*/}
                                        {/*</Grid>*/}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </>
            {/*)}*/}
        </CabinetAccordionDetails>
        </CabinetAccordion>
        <Snackbar
            className={classes.snackbarWrapper}
            ContentProps={{
                classes: {
                    root: classes.snackbar,
                    message: classes.snackbar,
                }
            }}
            TransitionComponent={TransitionUp}
            open={open}
            autoHideDuration={2000}
            onClose={handleSnackbarClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            message={<div className={classes.snackbarContentWrapper}>
                <div className={classes.snackbarContentHeader}>
                    Увага!
                </div>
                <div className={classes.snackbarContentText}>
                    {snackBarText && snackBarText}
                </div>
            </div >}
        >
        </Snackbar>
    </>;
}

export default AssayAccordion;